import script from "./ColdEmailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ColdEmailView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__